'use strict';

export default function routes($stateProvider) {
    'ngInject';

    $stateProvider.state('main.yearly_group_report', {
        template: '<yearly-group-report></yearly-group-report>'
    });
};



// WEBPACK FOOTER //
// ./public/dev/app/group_report/yearly/yearly_group_report.routes.js